import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type Choice = {
    answer: string;
    isCorrect: boolean;
  }
  
  type Question = {
    question: string;
    explanation: string;
    attachment: string;
    figure: string[];
    choices: Choice[];
  }
  
  type QuizDTO = {
    title: string;
    duration:string;
    certificateExamId:string;
    questions: Question[];
  } & ApiError

export const AddMockupExam = (data: QuizDTO): Promise<QuizDTO> => {
    return axios.post("/certificate-exam/create-mockup-exam", data)
        .then(response => response.data as QuizDTO);
};
